export default __webpack_public_path__ + "static/See where all your workers are in real-time@2x-2e081ed53ef0d7b763b3914b2e33522e.png";